import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageService} from '../../services/storage/storage.service';
import {Store} from '@ngxs/store';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {AppTourService} from '../../services/app-tour/app-tour.service';
import {animate, AUTO_STYLE, state, style, transition, trigger} from '@angular/animations';
import {DEFAULT_DURATION} from '../../animations/collapse.animation';
import {MainMenuHelperClass} from '../../class/helper/main-menu.helper.class';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class MobileMenuComponent extends MainMenuHelperClass implements OnInit, OnDestroy {
  @Input() hasPanelTemplate: boolean;

  constructor(
    public storageService: StorageService,
    public router: Router,
    public store: Store,
    public utilityService: UtilitiesService,
    public activatedRoute: ActivatedRoute,
    public appTourService: AppTourService
) {
    super(storageService, router, store, utilityService, activatedRoute, appTourService);
  }

  ngOnInit(): void {
    this.initValuesHttp().then();
  }

  ngOnDestroy(): void {
    this.$user.unsubscribe();
    this.$clinic.unsubscribe();
    this.$userClinics.unsubscribe();
    this.$active.unsubscribe();
  }
}
